import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { toast } from 'react-toastify';
import moment from 'moment';

import {
  getStudentCohortHistory,
  getCohortById,
} from '../../../../../../services/apiService';

const defaultColDef = {
  filter: true,
  sortable: true,
  resizable: true,
  menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
  headerComponentParams: {
    menuIcon: 'fa-bars',
    template: `<div class="ag-cell-label-container" role="presentation">  
                            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>  
                            <div ref="eLabel" class="ag-header-cell-label" role="presentation">    
                                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>    
                                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>    
                                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>    
                                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>    
                                <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>    
                                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>  
                            </div>
                        </div>`,
  },
};

const pageSize = 10;

function CohortHistory({ userId }) {
  const columnDefs = [
    { field: 'oldCohortName', headerName: 'Old Cohort' },
    { field: 'newCohortName', headerName: 'New Cohort' },
    { field: 'reasonOfChange', headerName: 'Reason Of Change' },
    {
      field: 'createdAt',
      headerName: 'Changed On',
      valueFormatter: (params) => {
        return params?.value
          ? moment(params?.value).format('DD MMM YYYY')
          : '-';
      },
    },
  ];

  const [rowData, setRowData] = useState(null);

  const fetchData = async () => {
    try {
      if (userId) {
        const response = await getStudentCohortHistory(userId);

        const mappedResponse = await Promise.all(
          response.map(async (changeItem = {}) => {
            let oldCohortName = '';
            let newCohortName = '';

            try {
              if (changeItem?.oldCohortId) {
                const oldCohortObj = await getCohortById(changeItem.oldCohortId);
                oldCohortName = oldCohortObj?.name || '';
              }

              if (changeItem?.newCohortId) {
                const newCohortObj = await getCohortById(changeItem.newCohortId);
                newCohortName = newCohortObj?.name || '';
              }
            } catch (err) {
              console.error('Cohort fetch failed', err);
            }

            return {
              oldCohortName,
              newCohortName,
              reasonOfChange: changeItem?.reasonOfChange || '',
              createdAt: changeItem?.createdAt || '',
            };
          })
        );

        setRowData(mappedResponse);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  };

  useEffect(() => {
    fetchData();
  }, [userId]);

  return (
    <div>
      <div className='ag-theme-alpine h-96  w-full'>
        <AgGridReact
          //   className='ag-theme-alpine'
          //   animateRows='true'
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          //   enableRangeSelection='true'
          rowData={rowData}
          rowSelection='multiple'
          suppressRowClickSelection='true'
          tooltipShowDelay={0}
          tooltipHideDelay={2000}
          pagination={true}
          paginationPageSize={pageSize}
          rowHeight={50}
        />
      </div>
    </div>
  );
}

export default CohortHistory;
